<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('myjobs')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <el-tooltip
            placement="top"
            :effect="themeMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('instruction')">
             <button
              type="button"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              @click="instructionOpen">
              <!-- {{ $t("instruction") }} -->
              <app-icon name="book-open" />
            </button>

          </el-tooltip>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
        <div class="alert alert-info" role="alert">
          <button type="button" class="close" @click.prevent="instructionClose">
            <h5 aria-hidden="true">&times;</h5>
          </button>
          <!-- <hr> -->
          <h5 class="alert-heading"><app-icon name="book-open" /> {{ $t("instructions_about_my_job") }}</h5>
          <p class="mb-0">{{ $t("introduction_my_job") }}</p>
          <strong>Actions:</strong>
          <ul>
            <li><strong>{{ $t("job_management") }} :</strong> {{ $t("job_management_action") }}</li>

          </ul>
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getListAction" />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../../../core/helpers/app/AppFunction";

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  props: {
    active: Object,
  },
  data() {
    return {
      instructionShow: false,
      selectedUrl: "",
      search: "",
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: actions.COMPANY_ASSIGN_JOBS,
        tableShadow: false,
        showHeader: true,
        columns: [
          // {
          //   title: this.$t("company"),
          //   type: "media-object",
          //   key: "media-object",
          //   mediaTitleKey: "title",
          //   mediaSubtitleKey: "location",
          //   default: AppFunction.getAppUrl("images/avatar-demo.jpg"),
          //   modifier: (value, row) => {
          //     return value; // imag url
          //   },
          //   isVisible: true,
          // },
          {
            title: this.$t("title"),
            type: "custom-html",
            key: "title",
            modifier: (value, row) => {
             return `<a href="#" id="${row.id}"  data-attribute="${row.id}" @click=${this.myFunction(row.id)}>${this.$t(value)}</a>`; 
            },
          },
          // {
          //   title: this.$t("company"),
          //   type: "custom-html",
          //   key: "accepted_bids",
          //   modifier: (value) => {
          //     return `<span>${this.$t(value[0].company_name)}</span>`;
          //   },
          // },
          {
            title: this.$t("start_date"),
            type: "custom-html",
            key: "start_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("end_date"),
            type: "custom-html",
            key: "end_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("job_type"),
            type: "custom-html",
            key: "job_type",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value, row) => {
              let ClassName = "warning";


              const date1 = new Date(row.end_date);
              const date2 = new Date();
              // One day in milliseconds
              const oneDay = 1000 * 60 * 60 * 24;
              // Calculating the time difference between two dates
              const diffInTime = date1.getTime() - date2.getTime();
              // Calculating the no. of days between two dates
              const diffInDays = Math.round(diffInTime / oneDay);

              if (value === "active") ClassName = `success`;
              else if (value === "inprogress") ClassName = `dark`;
              else if (value === "completed") ClassName = `primary`;
              else if (diffInDays <= 0) {ClassName = `danger`};


              return `<span class="text-capitalize badge badge-sm badge-pill badge-${diffInDays <= 0? 'danger' :ClassName}">${this.$t(
                diffInDays <= 0? 'Due' : value
              )}</span>`;
            },
          },
          // {
          //     title: this.$t('phone'),
          //     type: 'text',
          //     key: 'phone',
          // },
          // {
          //     title: this.$t('gender'),
          //     type: 'custom-html',
          //     key: 'gender',
          //     modifier: (value) => {
          //         return `<span>${this.$t(value)}</span>`
          //     }
          // },
        ],
        actions: [
          {
            title: this.$t("job_management"),
            icon: "clipboard",
            type: "none",
          },
        ],
        filters: [
          //   {
          //     title: this.$t("date"),
          //     type: "range-picker",
          //     key: "date",
          //     option: ["today", "thisMonth", "last7Days", "nextYear"],
          //   },
          // {
          //   title: this.$t("is_private"),
          //   type: "checkbox",
          //   key: "is_private",
          //   option: [
          //     { id: "0", value: "Public" },
          //     { id: "1", value: "Private" },
          //   ],
          // },
          // {
          //   title: this.$t("location"),
          //   type: "drop-down-filter",
          //   key: "search select",
          //   option: [
          //     { id: "0", value: "UK" },
          //     { id: "1", value: "USA" },
          //   ],
          // },
          // {
          //   title: this.$t("region"),
          //   type: "drop-down-filter",
          //   key: "search select",
          //   option: [
          //     { id: "0", value: "Public" },
          //     { id: "1", value: "Private" },
          //   ],
          // },
          // {
          //   title: this.$t("threshold"),
          //   type: "drop-down-filter",
          //   key: "search select",
          //   option: [
          //     { id: "0", value: "Threshold 1" },
          //     { id: "1", value: "Threshold 1" },
          //   ],
          // },
          //   {
          //     title: this.$t("status"),
          //     type: "checkbox",
          //     key: "status",
          //     option: [
          //       { id: "completed", value: "Completed" },
          //       { id: "incomplete", value: "Incomplete" },
          //       // {id: 'invited', value: 'Invited'},
          //     ],
          //   },
          // {
          //   title: this.$t("search_and_select_category"),
          //   type: "drop-down-filter",
          //   key: "search select",
          //   option: [],
          // },
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },

  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    getListAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("job_management")) {
        this.active = 2;
        this.$emit('jobId', rowData.id, this.active);
      }
    },
    view(id) {
        this.active = 2;
        this.$emit('jobId', id, this.active);
    },
    myFunction(id){
      let doc = document.getElementById(id);
      if(doc){
        doc.addEventListener('click', () => {
          this.view(doc.dataset.attribute)
        }) 
      }
    },

    searchAndSelectFilterOptions() {
      this.axiosGet(actions.CATEGORIES).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select_category")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.id,
            value: name.value,
          };
        });
      });
    },
  },
  computed: {
    themeMode() {
      return this.$store.state.theme;
    },
  },
};
</script>
